<template>
  <div class="col-12">
    <transition
      appear
      mode="out-in"
      enter-active-class="animated slideInRight faster"
      leave-active-class="animated slideOutRight faster"
    >
      <div class="last-transactions">
        <div class="row no-gutters">
          <div class="col-8 text-left">
            <H1 class="page-title">{{ $t("competition.allRewards.title") }}</H1>
          </div>
          <div class="col-4">
            <div class="all-link text-right">
              <router-link :to="'transactions'">{{
                $t("competition.transactions.allLink")
              }}</router-link>
            </div>
          </div>
        </div>
        <div v-if="needRecommendation" class="row no-gutters recommendation">
          <div class="col-12">
            <grouped-transactions :transaction="recommendation" :recommendation="true"/>
          </div>
        </div>
        <div
          class="row no-gutters"
          v-for="(transaction, index) in sortedTransactions"
          :key="index"
        >
          <div class="col-12">
            <grouped-transactions :transaction="transaction" />
          </div>
        </div>
        <div
          v-if="!transactions || transactions.length == 0"
          class="row no-gutters transactions-empty"
        >
          <h3>{{ $t("competition.transactions.empty.title") }}</h3>
          <div>{{ $t("competition.transactions.empty.text") }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GroupedTransactions from "@/components/transactions/GroupedTransactions";

export default {
  name: "RecentFeedbackList",
  props: {
    transactions: {
      type: Array,
    },
    recommendation: {
      type: Object,
      required: false,
    },
  },
  components: {
    GroupedTransactions,
  },
  data() {
    return {
      recommendationIndex: 0,
    };
  },
  computed: {
    sortedTransactions() {
      if (!this.transactions) {
        return undefined;
      }
      const sorted = this.transactions.slice();
      sorted.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      return sorted;
    },
    needRecommendation() {
      if (!this.transactions) {
        return false;
      }
      const feedbackIds = this.transactions.map(x => x._id);
      return (
        this.recommendation &&
        !feedbackIds.includes(this.recommendation._id)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.last-transactions {
  padding: 0 3%;
  .all-link {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: right;
    height: 100%;
    margin-right: 10px;
    margin-top: 20px;
  }
  .transactions-empty {
    background-color: rgba(250, 250, 250, 1);
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
  }
  .recommendation {
    .transaction-item {
      border: 2px dashed #ccc !important;
      border-radius: 8px;
    }
  }
}
</style>
